const ERROR_CODES = {
  ACCOUNT_NOT_CONFIRMED: "ACCOUNT_NOT_CONFIRMED",
  ROLE_NOT_ALLOWED: "ROLE_NOT_ALLOWED",
  IMAGE_TOO_LARGE:
    "El archivo es demasiado grande. El tamaño máximo permitido es 4MB.",
  IMAGE_INVALID_TYPE:
    "Formato de archivo no permitido. Solo se aceptan JPG, JPEG y PNG.",
  PHONE_INVALID_FORMAT:
    "El teléfono debe tener un formato válido. Ej: 11 5566 7788",
};

export default ERROR_CODES;
